export default {
  message: null,
  type: null,
};
